import styled from 'styled-components';

export const CampaignOverviewIcon = styled.div`
  padding: 12px 10px;
  background-color: #29b2bc;
  color: #fff;
  border-radius: 100%;
  margin-right: 10px;
`;

export const IconContainer = styled.div`
  padding: 14px 14px;
  width: fit-content;
  background-color: #29b2bc;
  color: #fff;
  border-radius: 100%;
  margin: 10px auto 20px auto;
`;
